<template>
    <i v-html="pathHtml(pathNum)"
        :class="['components-icons', _class]"></i>
</template>
<script>
import {ExtMapping} from '../config/index'
    export default {
        name: 'Icon',

        props: ['type', 'svg'],
        data(){
            return {
                
            }
        },
        computed: {
            pathNum () {
                let type = this.type.toLowerCase()
                let pathNum
                switch (type) {
                case 'wps' :
                case 'txt' :
                case 'note' :
                case 'xls' :
                case 'unknown' :
                case 'doc' :
                case 'docx' :
                case 'ppt' :
                case 'pdf' :
                case 'pof' :
                    pathNum = 3
                    break
                case 'img' :
                    pathNum = 4
                    break
                case 'pom' :
                    pathNum = 6
                    break
                case 'zip' :
                    pathNum = 11
                    break
                default:
                    pathNum = 4

                }
                return pathNum
            },
            _class () {
                return `components-icons-${this.type == 'folder' ? 'folder' : this._type}`
            },
            _type(){
                let type = this.type == 'folder' ? this.type.toLowerCase() : ''
                Object.keys(ExtMapping).map(key => {
                    ExtMapping[key].indexOf(this.type.toLowerCase()) > -1 ? type = key : ''
                })
                return type ? type : 'unknown'
            }
        },

        methods: {
            pathHtml (pathNum) {
                var paths = ''
                var num

                for (var i = 0; i < pathNum; i++) {
                    num = i + 1
                    paths = paths + "<span class='path" + num + "'></span>"
                }
                return paths
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Icon.vue